import React, { useEffect, useState,useMemo } from 'react';
import { DndContext, useDndMonitor } from '@dnd-kit/core';
import AvailableFields from './AvailableFields';
import RowLayout from './RowLayout';
import { fetchJson, updateMenuMetadata } from '@utils/fetchJson';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../../../config';
import { useCustomLayoutsStore } from '../store/CustomLayoutBuilderStore';
import CustomFieldBuilder from './CustomFieldBuilder';
import debounce from 'lodash/debounce';
import { X } from 'lucide-react';
export default function CustomLayoutBuilder({ onClose, onSave,onRefresh }) {
  const [availableFields, setAvailableFields] = useState([]);
    const [saving, setSaving] = useState(false);
    const [showFieldPopup, setShowFieldPopup] = useState(false);
    const [layoutRows, setLayoutRows] = useState([]);
    const [editField, setEditField] = useState(null);
    const { isOpen, payload,initialData, close } = useCustomLayoutsStore();
    const [moduleName,setModuleMame] = useState('');
    const [menuId, setmenuId] = useState(null);
   // const debouncedSave = debounce(saveLayout, 500);
    useEffect(() => {
      loadFields();
    }, [menuId]);
    useEffect(() => {
      
      if (payload?.payload) {
        setmenuId(payload?.payload.menuId);
        //setField({ ...defaultField, ...payload?.payload });
      }
      console.log(payload);
    }, [payload]);
  
    const handleEditField = (field) => {
      console.log("edit called");
      setEditField(field);            // Set the selected field for editing
      setShowFieldPopup(true);        // Open the popup
    };
    const loadFields = async () => {
      if(menuId === null) return;

        const [layoutRes, fieldsRes] = await Promise.all([
          fetchJson(`${API_BASE_URL}/menuMaster/${menuId}`),
          fetchJson(`${API_BASE_URL}/dynamicFormFieldList`, {
            method: 'POST',
            body: JSON.stringify({
              menuId: menuId?.toString(),
              status: 'active',
              getAll: 'Y'
            }),
          })
        ]);

      // layout parsing (you already have this)
      if (layoutRes?.flag === 'S') {
        const layoutObj = JSON.parse(layoutRes.data[0]?.metadata || '{}');
        setModuleMame(layoutRes.data[0]?.menuLink);
        const parsedRows = Object.keys(layoutObj).map((rowKey) => {
          const cols = layoutObj[rowKey];
          const colEntries = Object.entries(cols);
          const layout = String(colEntries.length);
          const columnArray = colEntries.map(([_, fields]) =>
            Array.isArray(fields) ? fields : []
          );
          return { layout, columns: columnArray };
        });
        setLayoutRows(parsedRows);
      }

      // ✅ now store all fields as available
      if (fieldsRes?.flag === 'S') {
        setAvailableFields(fieldsRes.data); // this keeps all possible fields
      }
    };

  const addNewRow = () => {
    const layout = '1';
    const numCols = parseInt(layout);
    const columns = Array.from({ length: numCols }, () => []);
    setLayoutRows((prev) => [...prev, { layout, columns }]);
  };

    useEffect(() => {


    }, [availableFields]);

  const updateMetadata = (field)=>{

    const deletedFields = availableFields.filter(f => f.fieldID === field.fieldID);

// Optionally log or use the deletedFields
console.log('Deleted:', deletedFields);

// Then update the state
setAvailableFields(prev => prev.filter(f => f.fieldID !== field.fieldID));

      console.log(deletedFields);
      let menuMeta = JSON.parse(localStorage.getItem(`user_columns_${menuId}`) || '[]');
      menuMeta = menuMeta.filter(col => col !== deletedFields[0]?.column_name);
      localStorage.setItem(`user_columns_${menuId}`, JSON.stringify(menuMeta));
      console.log("menuMeta");
      console.log(menuMeta);

    //updateMenuMetadata(menuMeta)
  }
  const deleteRow = async(rowIndexToRemove) => {
  const removedFields = [];

  // collect all fields from the row being removed
  const row = layoutRows[rowIndexToRemove];
  row.columns.forEach((col) => {
    col.forEach((field) => {
      if (field?.fieldID) removedFields.push(field);
    });
  });

  // remove the row
  const updatedRows = layoutRows.filter((_, i) => i !== rowIndexToRemove);
  setLayoutRows(updatedRows);

  // restore removed fields to availableFields (avoid duplicates)
  const restoredFields = removedFields.filter(
    (field) => !availableFields.some((f) => f.fieldID === field.fieldID)
  );
  setAvailableFields((prev) => [...prev, ...restoredFields]);
  await saveLayout(updatedRows);
};

  const saveLayout = async (rowsToSave = layoutRows) => {
  const layoutObj = {};
  setSaving(true);

  rowsToSave.forEach((row, idx) => {
    const cols = {};
    const layoutCount = parseInt(row.layout);
    for (let colIdx = 0; colIdx < layoutCount; colIdx++) {
      const colFields = row.columns[colIdx] || [];
      cols[`col${colIdx + 1}`] = colFields.map((f) => ({
        fieldID: f.fieldID,
        fieldLabel: f.fieldLabel,
        colSize: row.layout === '1' ? 12 : row.layout === '2' ? 6 : 4,
        fieldType: f.fieldType,
        column_name: f.column_name,
        linkedWith: f.linkedWith || '',
        fieldOptions: f.fieldOptions || '',
        dateFormat: f.dateFormat || '',
        displayFormat: f.displayFormat || '24-hours',
        parentCategory: f.parentCategory || '',
      }));
    }
    layoutObj[`row${idx + 1}`] = cols;
  });

  console.log("uploaded Layout", rowsToSave);
  const res = await fetchJson(`${API_BASE_URL}/metadata`, {
    method: 'POST',
    body: JSON.stringify({ menuId, htmlContent: JSON.stringify(layoutObj) }),
  });

  setSaving(false);
  if (res?.flag === 'S') {
    // check is module set 
    if(moduleName)
      updateMenuMetadata(moduleName, layoutObj);
    else{
      toast.success(' Layout updated successfully, but there was an issue applying the update to the local view.');
    }
    //toast.success('Layout saved');
  } else {
    toast.error(res.msg || 'Error saving layout');
  }
};
const updateRow = async (index, updatedRow) => {

    const updated = [...layoutRows];
    updated[index] = updatedRow;
    setLayoutRows(updated);
    // Remove field from available list
    // setAvailableFields((prev) =>
    //   prev.filter((f) => f.fieldID !== updatedRow.fieldID)
    // );
    // Save with updated data
    setTimeout(() => saveLayout(updated), 400);
  };

  const usedFieldIds = useMemo(() => {
  const used = new Set();
  layoutRows.forEach((row) => {
    row.columns.forEach((col) => {
      (col || []).forEach((field) => {
        if (field?.fieldID) used.add(field.fieldID);
      });
    });
  });
  return used;
}, [layoutRows]);

const filteredAvailableFields = useMemo(() => {
  return availableFields.filter((f) => !usedFieldIds.has(f.fieldID));
}, [availableFields, usedFieldIds]);

  // ✅ This is the nested hook-safe component
const DragListener = () => {
  useDndMonitor({
  // onDragEnd({ active, over }) {
  //   if (!active?.data?.current || !over) return;
  //   const { field, source } = active.data.current;
  //   const targetId = over.id;

  //   // 1) Dropped back to Available
  //   if (targetId === 'available-fields') {
  //     setLayoutRows((rows) =>
  //       rows.map((r) => ({
  //         ...r,
  //         columns: r.columns.map((col) => col.filter((f) => f.fieldID !== field.fieldID)),
  //       }))
  //     );
  //     setAvailableFields((prev) =>
  //       prev.some((f) => f.fieldID === field.fieldID) ? prev : [...prev, field]
  //     );
  //     return;
  //   }

  //   // 2) Dropped into a layout column
  //   const [, rowStr, , colStr] = targetId.split('-');
  //   const toRow = +rowStr,
  //     toCol = +colStr;
    
  //   setLayoutRows((rows) =>
  //     rows.map((r, rIdx) => {
  //       // Remove from source
  //       const newCols = r.columns.map((col) =>
  //         col.filter((f) => {
  //           // only remove if this is the source row/col
  //           if (
  //             source?.rowIndex === rIdx &&
  //             col === rows[source.rowIndex].columns[source.colIndex] &&
  //             f.fieldID === field.fieldID
  //           ) {
  //             return false;
  //           }
  //           return true;
  //         })
  //       );

  //       // Add to target
  //       if (rIdx === toRow) {
  //         const targetCol = newCols[toCol] || [];
  //         if (!targetCol.some((f) => f.fieldID === field.fieldID)) {
  //           newCols[toCol] = [...targetCol, field];
  //         }
  //       }

  //       return { ...r, columns: newCols };
  //     })
  //   );
  // },
  onDragEnd({ active, over }) {
  if (!active?.data?.current || !over) return;

  const { field, source } = active.data.current;
  const targetId = over.id;

  // === CASE 1: Dropped back to Available Fields ===
  if (targetId === 'available-fields') {
    const updatedRows = layoutRows.map((r) => ({
      ...r,
      columns: r.columns.map((col) =>
        col.filter((f) => f.fieldID !== field.fieldID)
      ),
    }));

    setLayoutRows(updatedRows);
    setAvailableFields((prev) =>
      prev.some((f) => f.fieldID === field.fieldID) ? prev : [...prev, field]
    );

    saveLayout(updatedRows); // ✅ auto-save
    return;
  }

  // === CASE 2: Dropped into a layout column ===
  const [, rowStr, , colStr] = targetId.split('-');
  const toRow = +rowStr;
  const toCol = +colStr;

  const updatedRows = layoutRows.map((r, rIdx) => {
    const newCols = r.columns.map((col) =>
      col.filter((f) => {
        if (
          source?.rowIndex === rIdx &&
          col === layoutRows[source.rowIndex].columns[source.colIndex] &&
          f.fieldID === field.fieldID
        ) {
          return false;
        }
        return true;
      })
    );

    if (rIdx === toRow) {
      const targetCol = newCols[toCol] || [];
      if (!targetCol.some((f) => f.fieldID === field.fieldID)) {
        newCols[toCol] = [...targetCol, field];
      }
    }

    return { ...r, columns: newCols };
  });

  setLayoutRows(updatedRows);
  saveLayout(updatedRows); // ✅ auto-save
}

});

  return null;
};

  if (!isOpen) return null;

  return (
    <div className='overlay-main-container'>
    <div className="modal-panel size-md fixed top-[50px] right-0 h-[calc(100vh-56px)] bg-white shadow-lg z-50 flex flex-col">
      <div className="sticky top-0 z-10 bg-gray-50 border-b p-3 shadow-sm flex justify-between items-center">
        <h2 className="text-lg text-gray-700 font-regular pl-3">Custom Layout & Fields</h2>
        <button onClick={()=>{close()}} className="absolute -left-3 rounded-full bg-white w-[28px] h-[28px] shadow-lg flex items-center justify-center">
          <X size={16} />
        </button>
      </div>
      <div className="flex-1 overflow-auto p-5 space-y-4">
        <button
          onClick={() => setShowFieldPopup(true)}
          className="bg-blue-600 text-white text-sm px-3 py-1 rounded hover:bg-blue-700">
          + Add Field
        </button>
      <DndContext>
      <DragListener /> {/* ✅ Must be rendered inside <DndContext> */}

      <div className="space-y-2">
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-1">
            <AvailableFields updateFields={(field) => {
              setAvailableFields((prev) =>
              prev.filter((f) => f.fieldID !== field.fieldID)
              );
            }}
            menuId={menuId} fields={filteredAvailableFields} /></div>
          <div className="col-span-2">{layoutRows.map((row, index) => (
            <RowLayout
              key={index}
              rowIndex={index}
              rowData={row}
              updateRow={updateRow}
              onDeleteField={(field) => {
                //need to update meta data to remove the feild as well
                updateMetadata(field);
                // setAvailableFields((prev) =>
                // prev.filter((f) => f.fieldID !== field.fieldID)
                // );
              }}
              availableFields={availableFields}
              onEdit={(field)=>{handleEditField(field)}}
              deleteRow={deleteRow}
            />
          ))}</div>
        </div>
        <div className="flex gap-2 justify-end border-t pt-4 mt-4">
          <button onClick={addNewRow} className="bg-gray-200 px-4 py-2 rounded">
            + Add Row
          </button>
        </div>
      </div>
    </DndContext>
    </div>
      <div className="p-4 border-t flex justify-end gap-2 bg-gray-50">
        <button onClick={onClose} className="border border-gray-300 text-gray-700 px-4 py-2 rounded">Cancel</button>
        <button onClick={() => saveLayout(layoutRows)} disabled={saving} className="bg-blue-600 text-white px-4 py-2 rounded">
            {saving ? 'Saving...' : 'Save Layout'}
          </button>
        {/* <button onClick={handleSubmit} disabled={saving} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded">
          {saving ? 'Saving...' : 'Save Field'}
        </button> */}
      </div>
      {showFieldPopup && (
        <div className='p-4'>
          <CustomFieldBuilder menuId={menuId} editField={editField} onSave={() =>{ loadFields();setShowFieldPopup(false)}} onClose={() => setShowFieldPopup(false)} />
        </div>
      )}
    </div>
    </div>
  );
}
